import { HttpClient, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { PRODUCTS_SERVICE_URL } from 'src/app/injection-tokens';
import { Observable, throwError } from 'rxjs';
import { Supplier, SupplierWithStats } from './supplier';

@Injectable({
  providedIn: 'root',
})
export class SupplierService {
  readonly serviceURL: string;

  constructor(
    @Inject(PRODUCTS_SERVICE_URL) readonly baseServiceURL: string,
    readonly http: HttpClient
  ) {
    this.serviceURL = baseServiceURL + '/suppliers';
  }

  createSupplier(supplier: Supplier): Observable<Supplier> {
    return this.http.post<Supplier>(this.serviceURL, supplier);
  }

  getSupplier(id: number): Observable<Supplier> {
    return this.http.get<Supplier>(`${this.serviceURL}/${id.toString()}`);
  }

  getSuppliers(): Observable<SupplierWithStats[]> {
    return this.http.get<SupplierWithStats[]>(this.serviceURL);
  }

  updateSupplier(supplier: Supplier): Observable<Supplier> {
    if (!supplier.id) {
      return throwError(() => new Error('Supplier id is required'));
    }
    return this.http.put<Supplier>(`${this.serviceURL}/${supplier.id.toString()}`, supplier);
  }

  deleteSupplier(supplier: Supplier): Observable<HttpResponse<null>> {
    if (!supplier.id) {
      return throwError(() => new Error('Supplier id is required'));
    }
    return this.http.delete<null>(
      `${this.serviceURL}/${supplier.id.toString()}`, //
      { observe: 'response' } //
    );
  }
}
